import Toast from '../components/pages/utils/Toast';
import { API } from '../constants/Constants';
import Instance from './interceptor';

export const createManualAuthCredential = async (
  newCredential,
  isUpdate,
  displayName,
) => {
  try {
    const response = await Instance.post(
      `${API.MANUAL_AUTH_CREDENTIAL}`,
      isUpdate
        ? newCredential
        : {
            newCredential,
            ...(displayName &&
              displayName.trim() !== '' && { display_name: displayName }),
          },
    );
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data?.newCredential;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};
export const updateCredentialData = async ({ id, payload, type }) => {
  try {
    const response = await Instance.patch(`${API.UPDATE_CREDENTIAL}/${id}`, {
      payload,
      selecteType: type,
    });
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data?.newCredential;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};
export const getAllTaxes = async (payload) => {
  try {
    const response = await Instance.post(`${API.GET_TAXES}`, payload);
    if (response) {
      return response?.data.allTax;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};
export const odooExport = async (invoiceIds, exportType, credentialId) => {
  const data = {
    invoiceIds,
    exportType,
    credentialId,
  };
  try {
    const response = await Instance.post(`${API.ODOO_EXPORT}`, data);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};
export const tallyPrimeExport = async (
  invoiceIds,
  exportType,
  credentialId,
) => {
  const data = {
    invoiceIds,
    exportType,
    credentialId,
  };
  try {
    const response = await Instance.post(`${API.TALLY_EXPORT}`, data);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const xeroExport = async (invoiceIds, exportType, credentialId) => {
  const data = {
    invoiceIds,
    exportType,
    credentialId,
  };
  try {
    const response = await Instance.post(`${API.XERO_EXPORT}`, data);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const zohoExport = async (invoiceIds, exportType, credentialId) => {
  const data = {
    invoiceIds,
    exportType,
    credentialId,
  };
  try {
    const response = await Instance.post(`${API.ZOHO_EXPORT}`, data);
    if (response) {
      Toast({ message: `${response?.data?.message}`, variant: 'success' });
      return response?.data;
    }
  } catch (error) {
    if (error?.response?.data?.message) {
      Toast({
        message: `${error?.response?.data?.message}`,
        variant: 'error',
      });
    } else {
      Toast({ message: `${error?.message}`, variant: 'error' });
    }
  }
};

export const quickBookExportManually = async (
  invoiceIds,
  exportType,
  credentialId,
  isNewAuthentication,
) => {
  const data = {
    invoiceIds,
    exportType,
    credentialId,
    isNewAuthentication,
  };
  try {
    const response = await Instance.post(
      `${API.QUICK_BOOK_MANUAL_EXPORT}`,
      data,
    );
    if (response?.data?.exportedData[0]) {
      return response.data.exportedData[0];
    }
  } catch (error) {
    Toast({ message: error?.response?.data?.message, variant: 'error' });
  }
};

export const tokenExchangeForQB = async (
  code,
  realmId,
  exportAndDocumentType,
) => {
  try {
    const response = await Instance.get(
      `${API.QB_AUTH_FLOW_CALLBACK}?code=${code}&realmId=${realmId}&exportType=${exportAndDocumentType}&documentType=${exportAndDocumentType}`,
    );
    if (response.data.response) {
      return response.data.response;
    }
    return response;
  } catch (error) {
    Toast({ message: `${error?.response?.data?.message}`, variant: 'error' });
  }
};
